export default "__VITE_ASSET__DrBa74Yk__"